import { Link } from 'react-router-dom';

const whyItems = [
  {
    icon: 'ri-shield-check-line',
    title: 'Fully Licensed & Insured',
    desc: 'We carry comprehensive liability insurance and are CPUC registered, giving you complete peace of mind on every move.',
    color: 'text-emerald-600',
    bg: 'bg-emerald-50',
  },
  {
    icon: 'ri-hand-coin-line',
    title: 'Transparent, Upfront Pricing',
    desc: 'You\'ll know the price before we start. No surprise charges, no hidden fees — just honest estimates and clear communication.',
    color: 'text-amber-600',
    bg: 'bg-amber-50',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Family-Owned & Local',
    desc: 'We\'re not a franchise or call center. We\'re a Southern California family business with real personal accountability on every job.',
    color: 'text-orange-600',
    bg: 'bg-orange-50',
  },
  {
    icon: 'ri-time-line',
    title: 'Punctual & Reliable',
    desc: 'Our crews arrive on time, every time. We respect your schedule and communicate proactively if anything changes.',
    color: 'text-sky-600',
    bg: 'bg-sky-50',
  },
  {
    icon: 'ri-star-smile-line',
    title: '4.6-Star Google Rating',
    desc: 'Our reputation is built on real customer experiences. Clients consistently praise our care, professionalism, and friendly service.',
    color: 'text-violet-600',
    bg: 'bg-violet-50',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: '3 Locations Across SoCal',
    desc: 'With offices in Orange County, Coachella Valley, and Long Beach, we\'re always close to where you need us most.',
    color: 'text-teal-600',
    bg: 'bg-teal-50',
  },
];

export default function ServicesWhyUs() {
  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Left content */}
          <div>
            <span className="inline-block bg-orange-100 text-orange-600 text-sm font-bold px-4 py-2 rounded-full mb-5">
              Why Choose Us
            </span>
            <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-5 leading-tight">
              Why Southern California Trusts City to City Moving
            </h2>
            <p className="text-slate-600 text-base leading-relaxed mb-8">
              We&apos;ve spent over 20 years building a reputation for reliability, care, and professionalism. Every move we make reinforces the trust our customers place in us.
            </p>

            {/* AI Answer Block */}
            <div className="bg-white rounded-2xl border border-orange-100 p-6 mb-8">
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-question-answer-line text-orange-500 text-lg"></i>
                <span className="text-sm font-black text-slate-900 uppercase tracking-wide">What moving services does City to City Moving Company offer?</span>
              </div>
              <p className="text-slate-600 text-sm leading-relaxed">
                City to City Moving Company offers residential moving, local moving, long-distance moving, office and commercial moving, professional packing and unpacking, loading and unloading labor, and specialty item moving for pianos, antiques, and fine art. We serve all of Southern California including Orange County, the Coachella Valley, Long Beach, and surrounding areas, and we handle interstate moves to all 50 states.
              </p>
            </div>

            <div className="flex flex-wrap gap-4">
              <a href="tel:7606257767"
                className="flex items-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 text-white px-7 py-3.5 rounded-xl font-bold hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap">
                <i className="ri-phone-fill"></i>Call Now — Free Quote
              </a>
              <Link to="/about"
                className="flex items-center gap-2 border border-slate-300 text-slate-700 px-7 py-3.5 rounded-xl font-semibold hover:bg-slate-100 transition-all whitespace-nowrap">
                <i className="ri-information-line"></i>About Our Company
              </Link>
            </div>
          </div>

          {/* Right: why cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {whyItems.map((item) => (
              <div key={item.title} className="bg-white rounded-2xl p-5 border border-gray-100 hover:-translate-y-1 transition-all duration-300">
                <div className={`w-11 h-11 flex items-center justify-center ${item.bg} rounded-xl mb-4`}>
                  <i className={`${item.icon} text-xl ${item.color}`}></i>
                </div>
                <h3 className="font-black text-slate-900 text-sm mb-2">{item.title}</h3>
                <p className="text-slate-600 text-xs leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
